import React from "react";
import { useLang } from "@/i18n/LanguageContext";

const GALLERY = [
  {
    src: "/gallery/house-in-1.jpg",
    span: "col-span-12 md:col-span-8 row-span-2 aspect-[16/11]",
    alt: "Villa Sućuraj — top left feature",
  },
  {
    src: "/gallery/house-in-2.jpg",
    span: "col-span-6 md:col-span-4 aspect-square",
    alt: "Villa Sućuraj — top right",
  },
  {
    src: "/gallery/house-5.jpg",
    span: "col-span-6 md:col-span-4 aspect-square",
    alt: "Villa Sućuraj — interior / detail",
  },
  {
    src: "/gallery/house-in-5.jpg",
    span: "col-span-12 md:col-span-7 aspect-[16/10]",
    alt: "Villa Sućuraj — bottom left",
  },
  {
    src: "/gallery/house-in-4.jpg",
    span: "col-span-12 md:col-span-5 aspect-[5/4]",
    alt: "Villa Sućuraj — bottom right",
  },
];

export const Gallery = () => {
  const { t } = useLang();

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-[#F8F5F0] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-16">
          <div className="md:col-span-7">
            <span className="text-xs uppercase tracking-[0.28em] text-[#8A9A86] font-semibold">
              {t.gallery.eyebrow}
            </span>
            <h2
              data-testid="gallery-title"
              className="mt-6 font-serif font-light text-[#2C302E] text-4xl md:text-5xl leading-[1.08] tracking-tight"
            >
              {t.gallery.title}
            </h2>
          </div>
          <p className="md:col-span-5 text-[#5C625E] text-base leading-relaxed font-light">
            {t.gallery.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-12 gap-3 md:gap-4">
          {GALLERY.map((img, i) => (
            <div
              key={i}
              data-testid={`gallery-image-${i}`}
              className={`${img.span} overflow-hidden group cursor-pointer`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000 ease-out"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
